type AdUnitMappings = {
  [key: string]: string
}

const adUnitMappings: AdUnitMappings = {
  'ad-banner-top': 'leaderboard_atf',
  'ad-banner-sidebar-top': 'siderail_right_article',
  'ad-mobile-footer': 'sticky_footer',
  'ad-banner-middle-1': 'leaderboard_btf_home_2',
  'ad-banner-middle-2': 'leaderboard_btf_home_3',
  'homepage-carousel-inline': 'side_scroll_300x250_1_home',
  'ad-story-byline-large': 'leaderboard_btf_article_1',
  'ad-banner-end-story': 'leaderboard_btf_article_2',
  'ad-story-collection': 'side_scroll_300x250_article',
  'ad-banner-middle-0': 'leaderboard_btf_home_1',
  'ad-banner-middle-mobile': 'leaderboard_middle-mobile',
  'ad-banner-sidebar': 'banner_sidebar',
  'ad-search-leaderboard': 'search_leaderboard',
  'ad-search-sidebar': 'search_sidebar',
  'ad-story-byline-small': 'story_byline_small',
  'ad-custom': 'ad-custom'
}

const mapAdUnitName = (name: string): string => {
  if (!adUnitMappings[name]) {
    console.log(`Warning: No mapping found for ad unit name: ${name}`)
  }

  return adUnitMappings[name] || name
}

export default mapAdUnitName
